/**
 * Заметное действие страницы в шапке приложения.
 *
 * Заведено 01.09 под claim-страницу: привязка аккаунта жила в доке внизу
 * экрана, наставник её пролистывал и не понимал, что делать со страницей.
 * Решение владельца — поднять действие наверх, рядом с логотипом.
 *
 * Модуль — крошечный реактивный синглтон вместо ещё одного стора: страница
 * объявляет своё действие на mount и снимает на unmount, шапка его рисует.
 * Vuex сюда тащить нечего — это UI-состояние одного экрана, а не данные.
 */
import { readonly, ref } from 'vue';

export interface HeaderCta {
    /** Подпись кнопки. */
    label: string;
    /** Что делает клик — обычно открывает диалог страницы. */
    onClick: () => void;
    /**
     * `gold` — единственный акцент такой яркости в приложении: он для
     * действия, ради которого страницу и открыли (забрать аккаунт).
     */
    tone?: 'gold' | 'violet';
    /** Метка для data-testid, чтобы тесты страницы находили кнопку. */
    testId?: string;
}

const cta = ref<HeaderCta | null>(null);

/** Объявить действие страницы. Повторный вызов заменяет прежнее. */
export const setHeaderCta = (value: HeaderCta): void => {
    cta.value = value;
};

/** Снять действие: страница ушла — кнопка не должна пережить её. */
export const clearHeaderCta = (): void => {
    cta.value = null;
};

/** Текущее действие для шапки; null — рисовать нечего. */
export const headerCta = readonly(cta);
